import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/redux/store.ts'
import { getCurrentQuarterRange } from '@/utils/time.ts'
import {
  MOBILE_VIEW_CARD_ORDER_DIRECTIONS,
  MOBILE_VIEW_CARD_ORDER_OPTIONS,
} from '@/common/constants/idea-list.constants.ts'

export const mobileViewCardOrderSel: string[] = (() =>
  MOBILE_VIEW_CARD_ORDER_OPTIONS.reduce(
    (acc, o) => [
      ...acc,
      ...MOBILE_VIEW_CARD_ORDER_DIRECTIONS.map((d) => `${o}/${d}`),
    ],
    [] as string[]
  ))()

type mobileViewCardOrderSel = (typeof mobileViewCardOrderSel)[number]

interface IdeaListInputState {
  category: string
  firm: string
  contributor: string
  dateRange: [string | null, string | null]
  onlyMyIdea: boolean
  showLiquidatedIdeas: boolean
  onlyPremiumLeague: boolean
  bookId: string
  mobileView: 'card' | 'table'
  mobileViewCardOrder: mobileViewCardOrderSel | ''
}

export const ideaListInputSlice = createSlice({
  name: 'ideaListInput',
  initialState: {
    category: '',
    firm: '',
    contributor: '',
    dateRange: getCurrentQuarterRange() as [string, string],
    onlyMyIdea: true,
    showLiquidatedIdeas: false,
    onlyPremiumLeague: false,
    bookId: '',
    mobileView: 'card',
    mobileViewCardOrder: '',
  } as IdeaListInputState,
  reducers: {
    setIdeaListCategory(state, action) {
      state.category = action.payload
    },
    setIdeaListFirm(state, action) {
      state.firm = action.payload
    },
    setIdeaListContributor(state, action) {
      state.contributor = action.payload
    },
    setIdeaListDateRange(state, action) {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
    toggleOnlyMyIdea(state, action) {
      state.onlyMyIdea = action.payload
    },
    toggleShowLiquidatedIdeas(state, action) {
      state.showLiquidatedIdeas = action.payload
    },
    toggleOnlyPremiumLeague(state, action) {
      state.onlyPremiumLeague = action.payload
    },
    setBookId(state, action) {
      state.bookId = action.payload
    },
    setMobileView(state, action) {
      state.mobileView = action.payload
    },
    setMobileViewCardOrder(state, action) {
      state.mobileViewCardOrder = action.payload
    },
  },
})

export const selectIdeaListInput = (state: RootState) => state.ideaListInput

export const {
  setIdeaListCategory,
  setIdeaListFirm,
  setIdeaListContributor,
  setIdeaListDateRange,
  toggleOnlyMyIdea,
  toggleShowLiquidatedIdeas,
  toggleOnlyPremiumLeague,
  setBookId,
  setMobileView,
  setMobileViewCardOrder,
} = ideaListInputSlice.actions
